import { externalProgram } from "../../common_nextgen/utils/Constants";

export const formFields = [
  {
    section: "General Information",
    name: "dscScheduleName",
    label: "Schedule",
    fieldLabel: "DSC Schedule Name",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 10, message: "MAXLENGTH_10" },
    },
    fieldNature: "Add: Editable, Change: Read-only, View: Read-only",
    position: [1, 1],
  },
  {
    section: "General Information",
    name: "dscDescription",
    label: "Description",
    fieldLabel: "DSC Description",
    type: "text",
    options: {
      required: { value: true, message: "REQUIRED" },
      maxLength: { value: 40, message: "MAXLENGTH_40" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [2, 1],
  },
  {
    section: "General Information",
    name: "dscDispOutdatedRcds",
    label: "Display",
    fieldLabel: "DSC Disp Outdated Rcds?",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [3, 1],
  },
  {
    section: "General Information",
    name: "dscBasis",
    label: "Basis",
    fieldLabel: "DSC Basis",
    type: "dropdown",
    dropdownCondition: "*Valid values",
    options: { required: { value: true, message: "REQUIRED" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [4, 1],
  },
  {
    section: "General Information",
    name: "wrkNumber",
    label: "Steps",
    fieldLabel: "Wrk Number",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99, message: "MAX_99" },
    },
    fieldNature: "Add: Read-only, Change: Read-Only, View: Read-only",
    position: [5, 1],
  },
  {
    section: "General Information",
    name: "planCode",
    label: "Member Override Plan",
    fieldLabel: "Plan Code",
    type: "lookup",
    externalProgram: { default: "RCPLN018" },
    params: {
      lookupType: "local",
      viewType: "legacy",
      fieldMapping: {
        default: [
          { source: "planCode", target: "planCode",legacy:"planCode" },
          { source: "planEffDate", 
            resolver:"formatDateForPresto",
            legacy:"planEffDate",
            target: "planEffDate" },
          { source: "planName", target: "planName",legacy:"planName" },
        ],
      },
    },
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [6, 1],
  },
  {
    section: "General Information",
    name: "planName",
    label: "",
    fieldLabel: "Plan Name",
    type: "text",
    options: { maxLength: { value: 25, message: "MAXLENGTH_25" } },
    fieldNature: "Add: Read-only, Change: Read-only, View: Read-only",
    position: [6, 2],
  },
  {
    section: "General Information",
    name: "planEffDate",
    label: "Plan Effective Date",
    fieldLabel: "Plan Eff Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [7, 1],
  },
  {
    section: "General Information",
    name: "dscMbrFromDateSwitch",
    label: "Member From Date Based On",
    fieldLabel: "DSC Mbr From Date Switch",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 1],
  },
  {
    section: "General Information",
    name: "dscMbrFromDate",
    label: "Date",
    fieldLabel: "DSC Mbr From Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [8, 1],
  },
  {
    section: "General Information",
    name: "dscMbrThruDateSwitch",
    label: "Member Thru Date Based On",
    fieldLabel: "DSC Mbr Thru Date Switch",
    type: "dropdown",
    dropdownCondition: "*ALL values",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 1],
  },
  {
    section: "General Information",
    name: "dscMbrThruDaysAdded",
    label: "+ Days",
    fieldLabel: "DSC Mbr Thru Days Added",
    type: "number",
    options: {
      min: { value: 0, message: "MIN_0" },
      max: { value: 99999, message: "MAX_99999" },
    },
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 2],
  },
  {
    section: "General Information",
    name: "dscMbrThruDate",
    label: "Date",
    fieldLabel: "DSC Mbr Thru Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Editable, Change: Editable, View: Read-only",
    position: [9, 3],
  },
  {
    section: "Audit Fields",
    name: "addedDate",
    label: "Added",
    fieldLabel: "ADD Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: read-only",
    position: [10, 1],
  },
  {
    section: "Audit Fields",
    name: "changedDate",
    label: "Changed",
    fieldLabel: "CHG Date",
    type: "date",
    format: "MM/DD/YYYY",
    options: {},
    fieldNature: "Add: Non-Display, Change: Read-only, View: read-only",
    position: [10, 2],
  },
  {
    section: "Audit Fields",
    name: "changedUser",
    label: "User",
    fieldLabel: "CHG User",
    type: "text",
    options: { maxLength: { value: 10, message: "MAXLENGTH_10" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: read-only",
    position: [10, 3],
  },
  {
    section: "Audit Fields",
    name: "noteExistenceStatus",
    label: "Note Exists",
    fieldLabel: "Note Existence Status",
    type: "text",
    options: { maxLength: { value: 15, message: "MAXLENGTH_15" } },
    fieldNature: "Add: Non-Display, Change: Read-only, View: read-only",
    position: [10, 4],
  },
];
